export default __webpack_public_path__ + "images/btcIcon_2d852c.svg";